import { render, staticRenderFns } from "./facebook-auth.vue?vue&type=template&id=c6d2afbe&scoped=true&"
import script from "./facebook-auth.vue?vue&type=script&lang=js&"
export * from "./facebook-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2afbe",
  null
  
)

export default component.exports